<template>
  <div v-if="showOverlay" class="trial-expired-overlay">
    <div class="trial-expired-modal">
      <div class="modal-content">
        <h2>Free Trial Expired</h2>
        <p>Your 30-day free trial has ended. Upgrade to a paid plan to continue using IntegrateMe.</p>
        
        <div class="upgrade-benefits">
          <h3>Continue with full access to:</h3>
          <ul>
            <li>Unlimited employee onboarding</li>
            <li>Custom checklist creation</li>
            <li>Team management</li>
            <li>Progress tracking</li>
          </ul>
        </div>
        
        <div class="action-buttons">
          <button @click="goToPricing" class="upgrade-btn">
            Upgrade Now
          </button>
          <button @click="contactSupport" class="contact-btn">
            Contact Support
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps({
  company: {
    type: Object,
    required: true
  }
})

const router = useRouter()

const showOverlay = computed(() => {
  return props.company?.requires_upgrade === true
})

const goToPricing = () => {
  router.push('/account/subscription')
}

const contactSupport = () => {
  window.location.href = 'mailto:support@integrateme.co.nz?subject=Trial Upgrade Support'
}
</script>

<style scoped>
.trial-expired-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(5px);
}

.trial-expired-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-content {
  padding: 40px 32px;
  text-align: center;
}

.modal-content h2 {
  color: #dc3545;
  margin-bottom: 16px;
  font-size: 28px;
  font-weight: 600;
}

.modal-content p {
  color: #6c757d;
  margin-bottom: 32px;
  font-size: 16px;
  line-height: 1.6;
}

.upgrade-benefits {
  text-align: left;
  margin-bottom: 32px;
  padding: 24px;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.upgrade-benefits h3 {
  color: #343a40;
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 600;
}

.upgrade-benefits ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.upgrade-benefits li {
  color: #495057;
  margin-bottom: 8px;
  position: relative;
  padding-left: 24px;
  font-size: 14px;
}

.upgrade-benefits li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #28a745;
  font-weight: bold;
}

.action-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.upgrade-btn {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 14px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.upgrade-btn:hover {
  background-color: #0056b3;
}

.contact-btn {
  background-color: transparent;
  color: #6c757d;
  border: 2px solid #dee2e6;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.contact-btn:hover {
  color: #495057;
  border-color: #adb5bd;
}

@media (max-width: 768px) {
  .modal-content {
    padding: 24px 20px;
  }
  
  .action-buttons {
    flex-direction: column;
  }
  
  .upgrade-btn, .contact-btn {
    width: 100%;
  }
}
</style>